import { render, staticRenderFns } from "./ChatbotConversation.vue?vue&type=template&id=56cd622b&scoped=true&"
import script from "./ChatbotConversation.vue?vue&type=script&lang=js&"
export * from "./ChatbotConversation.vue?vue&type=script&lang=js&"
import style0 from "./ChatbotConversation.vue?vue&type=style&index=0&id=56cd622b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cd622b",
  null
  
)

export default component.exports